import React, { FC, useContext } from 'react'
import ManageContext from '../contexts/manage'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import FileList from '@kaidam/fc-frontend/src/components/booking/FileList'

import Form from '@kaidam/fc-frontend/src/components/form/Wrapper'

import {
  yearfeedbackSchema,
  yearfeedbackValidation,
} from '@kaidam/fc-frontend/src/components/booking/forms'

const ManageMonthFeedback: FC<React.PropsWithChildren<unknown>> = ({}) => {
  const manage = useContext(ManageContext)

  return (
    <>
      <Form
        readonly={false}
        validationSchema={yearfeedbackValidation}         
        error={""}
        initialValues={manage.data.booking.data.yearfeedback || {}}
        onSubmit={(yearfeedback) => {
          manage.update({
            yearfeedback,
          }, 'yearfeedback')
        }}
      >
        {({
          render,
          setFieldValue,
          values,
          showErrors,
          errors,
          isValid,
          onSubmit,
        }) => {
          return (
            <Box sx={{
              display: 'flex',
              p: 2,
              '& .MuiPaper-root': {
                width: '100%',
                p: 3,
              }
            }}>
              <div>
                {render(yearfeedbackSchema)}
                <Box>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle1">Additional Files</Typography>
                  <FileList
                    readonly={false}
                    token={manage.token}
                    path="yearfeedback"
                    data={values.files || []}
                    onChange={(files) => {
                      setFieldValue('files', files)
                    }}
                  />
                </Box>
                <Button
                  disabled={false}
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </div>
            </Box>
          )
        }}               
      </Form>
    </>
  )
}

export default ManageMonthFeedback